export function deep_clone(value: any) {
  if (typeof value != 'object') {
    return value;
  }

  let obj = value;
  let newObj: Array<any> | any;

  if (obj instanceof Array) {
    newObj = [];
  } else if (typeof obj == 'object') {
    newObj = {};
  }

  for (let k in obj) {
    let v = obj[k]

    if (obj instanceof Array) {
      newObj.push(deep_clone(v))
    } else
      if (typeof obj === 'object') {
        newObj[k] = deep_clone(v)
      } else {
        //should not arrive at this point
      }
  }

  return newObj
}
